import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api } from '../services/api';
import LazyImage from '../components/LazyImage';
import { RotatingLines } from 'react-loader-spinner';
import { getImageUrl } from '../utils/imageUtils';

const Container = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.large};
  margin: 0 auto;
  padding: 2rem;
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 1rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
`;

const MemberCard = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.small};
  text-align: center;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-5px);
  }
`;

const ImageContainer = styled.div`
  height: 250px;
  width: 100%;
`;

const Content = styled.div`
  padding: 1.5rem;
`;

const Name = styled.h3`
  margin: 0.5rem 0;
  color: ${({ theme }) => theme.colors.secondary};
`;

const Role = styled.h4`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.tertiary};
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const Bio = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.textLight};
`;

const Team = () => {
  const [header, setHeader] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get('/team/header'), api.get('/team/members')])
      .then(([h, m]) => {
        setHeader(h);
        setMembers(m);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{display:'flex', justifyContent:'center', marginTop:'50px', minHeight:'100vh'}}>
      <RotatingLines strokeColor="grey" width="50" />
    </div>
  );

  return (
    <Container>
      {header && (
        <HeaderSection>
          <Title>{header.title}</Title>
          <p>{header.description}</p>
           {header.image && (
                <div style={{height: '300px', marginTop: '2rem', borderRadius:'8px', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', background:'#f0f0f0'}}>
                    <img src={getImageUrl(header.image)} alt={header.title} style={{width:'100%', height:'100%', objectFit:'contain'}} />
                </div>
            )}
        </HeaderSection>
      )}

      <Grid>
        {members.map(member => (
          <MemberCard key={member._id}>
            <ImageContainer>
               {member.image ? (
                 <LazyImage src={member.image} alt={member.name} />
               ) : (
                 <div style={{background:'#eee', width:'100%', height:'100%'}} />
               )}
            </ImageContainer>
            <Content>
              <Name>{member.name}</Name>
              <Role>{member.role}</Role>
              <Bio>{member.description}</Bio>
            </Content>
          </MemberCard>
        ))}
      </Grid>
    </Container>
  );
};

export default Team;
